import { STEPS } from "@/data/content";
import { Reveal, SectionLabel, CtaButton } from "@/components/landing/shared";

export const HowItWorks = () => (
  <section id="how-it-works" className="border-t border-zinc-900 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <SectionLabel index="02" testid="how-label">
          How it works
        </SectionLabel>
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold leading-none tracking-tight sm:text-5xl">
          From brief to scroll-stopper in four steps.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-zinc-900 bg-zinc-900 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08}>
            <div
              className="group h-full bg-[#0a0a0a] p-8 transition-colors duration-300 hover:bg-[#101010]"
              data-testid={`step-${s.n}`}
            >
              <span className="font-display text-5xl font-extrabold text-zinc-800 transition-colors duration-300 group-hover:text-white">
                {s.n}
              </span>
              <h3 className="mt-6 text-xl font-semibold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-500">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-12">
          <CtaButton testid="how-cta">Send the brief</CtaButton>
        </div>
      </Reveal>
    </div>
  </section>
);
